export default class ConditionalStyleSettingsModule {
    /**
     * 
     * @param styleSettings 
     * @param territoryModel 
     * 
     * @returns 
     */
    getRequiredAttributes(styleSettings, territoryModel): string[] {
        const attrs = ['ES_ID']; // always?! server-side also always adds it...
        
        attrs.push.apply(attrs, styleSettings.conditionalStyles.map((conditionalStyle) => {
            return conditionalStyle.attrValueCriteria.attr;
        }));
        
        return _.uniq(attrs);
    }
}
